/**
 * Debe ser el PRIMER import de index.js (sin dependencias de React).
 * Si se ejecuta después de Chart/Swal/etc., ResizeObserver nativo ya se usó y el overlay sigue mostrando el aviso benigno.
 */
/* eslint-disable no-console */

const shouldIgnore = (msg) =>
  typeof msg === 'string' &&
  (msg.includes('ResizeObserver loop') || msg.includes('undelivered notifications'));

if (typeof window !== 'undefined' && typeof window.ResizeObserver === 'function') {
  const NativeRO = window.ResizeObserver;
  window.ResizeObserver = class extends NativeRO {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          try {
            callback(entries, observer);
          } catch (_) {
            /* noop */
          }
        });
      });
    }
  };
}

if (typeof window !== 'undefined') {
  window.addEventListener(
    'error',
    (e) => {
      const msg = e?.message || e?.error?.message || '';
      if (shouldIgnore(msg)) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    },
    true
  );

  const prevOnError = window.onerror;
  window.onerror = function (message, source, lineno, colno, error) {
    const msg =
      typeof message === 'string' ? message : error?.message || '';
    if (shouldIgnore(msg)) return true;
    if (typeof prevOnError === 'function') {
      return prevOnError.apply(this, arguments);
    }
    return false;
  };

  if (process.env.NODE_ENV === 'development') {
    const origErr = console.error;
    console.error = (...args) => {
      const first = args[0];
      const msg =
        typeof first === 'string'
          ? first
          : first?.message
            ? String(first.message)
            : '';
      if (shouldIgnore(msg)) return;
      origErr.apply(console, args);
    };
  }

  // Algunos navegadores / overlays usan reportError en lugar del evento error
  if (typeof window.reportError === 'function') {
    const origReport = window.reportError.bind(window);
    window.reportError = (err) => {
      const msg = err && err.message ? String(err.message) : '';
      if (shouldIgnore(msg)) return;
      origReport(err);
    };
  }
}
